module.exports = "<div class=\"row\">\n  <div class=\"col-xs-12\">\n    <div class=\"score-progress-bar\" [ngStyle]=\"{'height': config.thickness}\">\n      <div class=\"filled\" [ngStyle]=\"{'background-color': backgroundColor, width: score}\"></div>\n    </div>\n    <div class=\"labels\">\n      <div>0%</div>\n      <div class=\"max-label\">100%</div>\n    </div>\n    <div class=\"passing-score-label\" *ngIf=\"isPassingTextEnabled\">\n      Score a {{config.passingScore}}% to pass!\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/score-progress-bar/score-progress-bar.html
// module id = kned
// module chunks = 3